import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import useResizeObserver from 'use-resize-observer';

const CalculationHeight = ({ children }) => {
    const sendPostMessage = (message) => {
        // eslint-disable-next-line no-restricted-globals
        parent.postMessage(message, '*');
    };

    const onResize = useCallback(({ height = 0 }) => {
        sendPostMessage({ height });
    }, []);

    const { ref } = useResizeObserver({ onResize });

    return <div ref={ref}>{children}</div>;
};

export default observer(CalculationHeight);
